<script lang="ts">
  // Einstellungen: Lautstärken, Schriftgröße, Farbsehschwäche, Untertitel, reduzierte Bewegung
  import { settings } from '../settings.ts';
  import { audio, type Bus } from '../audio/audio.ts';
  import { t } from '../i18n.ts';

  let { onBack }: { onBack: () => void } = $props();
  let vol = $state({ ...audio.settings });
  function setVol(b: Bus | 'master', v: number) {
    vol[b] = v;
    audio.setVolume(b, v);
    if (b === 'sfx') audio.sfx('pickup');
  }
</script>

<div class="list" data-testid="settings">
  <h2>{t('settings.title')}</h2>
  <fieldset>
    <legend>{t('settings.audio')}</legend>
    {#each ['master', 'music', 'ambience', 'sfx'] as b}
      <label class="row">
        <span>{t('settings.vol.' + b)}</span>
        <input type="range" min="0" max="1" step="0.05" value={vol[b as Bus]} oninput={(e) => setVol(b as Bus, Number((e.target as HTMLInputElement).value))} data-testid={'vol-' + b} />
      </label>
    {/each}
  </fieldset>
  <fieldset>
    <legend>{t('settings.view')}</legend>
    <label class="row">
      <span>{t('settings.fontScale')}</span>
      <input type="range" min="0.9" max="1.5" step="0.1" bind:value={$settings.fontScale} data-testid="font-scale" />
    </label>
    <label class="check"><input type="checkbox" bind:checked={$settings.colorblind} data-testid="colorblind" /> {t('settings.colorblind')}</label>
    <label class="check"><input type="checkbox" bind:checked={$settings.subtitles} data-testid="subtitles" /> {t('settings.subtitles')}</label>
    <label class="check"><input type="checkbox" bind:checked={$settings.reducedMotion} /> {t('settings.reducedMotion')}</label>
  </fieldset>
  <fieldset class="keys" data-testid="shortcuts">
    <legend>{t('settings.keys')}</legend>
    <dl>
      {#each ['esc', 'h', 'a', 'k', 'space', 'f', 'num', 'right'] as k}
        <dt><kbd>{t('settings.key.' + k + '.key')}</kbd></dt>
        <dd>{t('settings.key.' + k + '.what')}</dd>
      {/each}
    </dl>
  </fieldset>
  <button class="btn" onclick={onBack}>{t('menu.back')}</button>
</div>

<style>
  .list {
    display: grid;
    gap: 12px;
    text-align: left;
  }
  h2 {
    font-family: var(--font-display);
    margin: 0 0 4px;
    color: var(--amber2);
    text-align: center;
  }
  fieldset {
    border: 1px solid var(--panel-edge);
    border-radius: 12px;
    padding: 10px 12px;
    display: grid;
    gap: 6px;
  }
  legend {
    color: var(--amber2);
    font-weight: 700;
    padding: 0 6px;
  }
  .row {
    display: grid;
    grid-template-columns: 1fr 1.3fr;
    align-items: center;
    gap: 10px;
    min-height: 44px;
  }
  input[type='range'] {
    accent-color: var(--amber1);
    min-width: 0;
  }
  .check {
    display: flex;
    gap: 10px;
    align-items: center;
    min-height: 44px;
  }
  .check input {
    width: 22px;
    height: 22px;
    accent-color: var(--amber1);
  }
  .keys dl {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 4px 12px;
    margin: 0;
  }
  .keys dd {
    margin: 0;
  }
  kbd {
    font: inherit;
    font-weight: 700;
    padding: 1px 6px;
    border-radius: 5px;
    border: 1px solid rgba(239, 226, 196, 0.4);
    background: rgba(239, 226, 196, 0.08);
  }
</style>
